export default __webpack_public_path__ + "static/media/inner_circle.65ab9656.svg";